// extracted by mini-css-extract-plugin
export default {"rating":"cK-z","numberOfStars":"dK-z","count":"eK-z","barGraphSpacing":"fK-z","barGraph":"gK-z"};